module.exports = __webpack_public_path__ + "assets/img/id-energias-logo-small.47c2dd09.png";